import useAppStore from "@/context/store";
import _ from "lodash";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const useLaunchBottomVisibility = () => {
  const router = useRouter();
  const pathname = router.pathname;
  const isHidePage = pathname === "/" || pathname === "/index";
  const { user, userReady } = useAppStore(({ user, userReady, config }) => ({
    user,
    userReady,
    config,
  }));
  const disabled = !userReady || user;

  const [visible, setVisible] = useState(isHidePage);

  useEffect(() => {
    const onWheel = _.throttle((evt) => {
      if (evt.wheelDelta <= 0) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    }, 500);

    if (disabled) {
      return;
    }
    if (!isHidePage) {
      window.addEventListener("wheel", onWheel, { passive: true });
      return () => {
        window.removeEventListener("wheel", onWheel);
      };
    }
  }, [disabled, isHidePage]);

  return {
    launchBottomVisible: visible,
    launchBottomDisabled: disabled,
    launchBottomIsHidePage: isHidePage,
  };
};

export default useLaunchBottomVisibility;
